<template>
  <div class="header">
    <h1 class="mdc-typography--display1">Whata</h1>
    <h2 class="mdc-typography--display5">save the planet - classify water</h2>
  </div>
</template>

<script>
import { MDCTemporaryDrawerFoundation } from '@material/drawer'
import * as utils from '@material/drawer/util'

export default {
  name: 'Header',

  mounted () {
  },

  data () {
    return {
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Header.vue?8f3f4748